import { ENDPOINTS } from "@/constants/endpoints";
import { api } from "../network/api";
import type { InAppNotificationListResponse } from "@/models/responses/in-app-notification.response";

const InAppNotificationService = {
  getNotifications: async function (params: {
    page?: number;
    limit?: number;
    unreadOnly?: boolean;
  }): Promise<InAppNotificationListResponse> {
    const response = await api.get(ENDPOINTS.NOTIFICATIONS.GET_IN_APP(params));
    return response as unknown as InAppNotificationListResponse;
  },
  getUnreadCount: async function (): Promise<{ count: number }> {
    const response = await api.get(ENDPOINTS.NOTIFICATIONS.GET_UNREAD_COUNT);
    return response.data;
  },
  markRead: async function (ids?: string[]): Promise<{ updated: number }> {
    const response = await api.patch(ENDPOINTS.NOTIFICATIONS.MARK_READ, {
      ids,
    });
    return response.data;
  },
};

export default InAppNotificationService;
